import React, { useState, useEffect, useRef, useMemo } from "react";
import PlaylistVideoPlayer from "./PlaylistVideoPlayer";
import StyleRenderer from "./StyleRenderer";

const Playlist = ({ attributes, nonce }) => {
  const { videos, styles, options, uniqueId } = attributes;
  const [currentVideo, setCurrentVideo] = useState(videos?.[0] || {});
  const [currentIndex, setCurrentIndex] = useState(0);
  const [player, setPlayer] = useState(null);
  const ref = useRef();

  console.log(attributes);


  useEffect(() => {
    setTimeout(() => {
      if (ref.current) {
        ref.current.querySelector(".video__right").style.height = ref.current.querySelector(".video__left .video__main").offsetHeight + "px";
      }
    }, 100);
  }, [currentVideo]);

  useEffect(() => {
    if (player && options.autoplayNextVideo) {
      player.on("ended", () => {
        const currentVideo = document.querySelector(`.item-active`);
        // window.currentVideo = currentVideo;
        const nextIndex = currentVideo.nextElementSibling?.dataset?.index || 0;
        // console.log({ nextIndex });
        if (nextIndex) {
          setCurrentIndex(nextIndex);
        }
      });
    }
  }, [player]);

  useEffect(() => {
    window.currentIndex = currentIndex;
    setCurrentVideo(videos[currentIndex] || videos[0]);
    document.querySelectorAll(`.item-active`).forEach((item) => {
      item.classList.remove("item-active");
    });
    document.querySelector(`.video-item[data-index="${currentIndex}"]`)?.classList.add("item-active");
  }, [currentIndex]);

  return (
    <div id={uniqueId} className="video video--bg" ref={ref}>
      <StyleRenderer styles={styles} uniqueId={uniqueId} />
      <div className="h5vp_playlist_container">
        <div className="video__left video__wrapper">
          <PlaylistVideoPlayer video={currentVideo} options={options} player={player} setPlayer={setPlayer} />
        </div>
        <div className="video__right video__wrapper" style={{ aspectRatio: "4/4.3", overflow: "hidden" }}>
          {videos.map((video, index) => {
            const { video_thumb, video_source, video_title, video_desc, h5vp_video_provider } = video;
            return (
              <div
                key={index}
                className={`video-item video-item-${index} ${currentIndex === index ? "item-active" : ""}`}
                onClick={() => {
                  setCurrentVideo(video);
                  setCurrentIndex(index);
                }}
                data-index={index}
              >
                <div className="video-block">
                  <div className="video-block__container video__container">
                    <div className="video__thumb video__thumb--small">
                      <img src={video_thumb} alt="video" />
                    </div>
                  </div>
                  <div className="video-block__content">
                    <h2 title={video_title} className="video-block__title video-block__title--small">
                      {video_title}
                    </h2>
                    {/* <span className="video-block__user-name meta">SOMOY TV Bulletin</span> */}
                    {/* <span className="video-block__views meta">
                      6.5<span>M</span> views
                    </span> */}
                    <p className="video-block__description">{video_desc} </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Playlist;
